import React from "react";
import { Clock, BookOpen, Users, Award } from "lucide-react";
import SectionHeading from "../ui/SectionHeading";

const AboutContent = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Our Story"
          subtitle="Professional Service Associates has been providing exceptional Tax, VAT, RJSC, BIDA and business consultancy services since 2008."
          center
        />

        <div className="max-w-4xl mx-auto mt-8">
          <p className="text-gray-700 mb-6 text-lg leading-relaxed">
            Founded by Mr. Masum Miah, a distinguished Income Tax Lawyer, VAT
            Consultant and RJSC Practitioner. Professional Service Associates
            (PSA) has established itself as a trusted partner for businesses and
            individuals seeking expert financial guidance in Bangladesh.
          </p>

          <p className="text-gray-700 mb-6 text-lg leading-relaxed">
            Our journey began with a simple mission: to provide accessible,
            reliable, and high-quality Tax, VAT, RJSC, BIDA and business
            consultancy services that help our clients navigate complex
            financial regulations and achieve their objectives.
          </p>

          <p className="text-gray-700 mb-6 text-lg leading-relaxed">
            Today, with offices in Mirpur and Kakrail, Dhaka, we continue to
            expand our services while maintaining our commitment to personalized
            attention and exceptional care. Our team of experienced
            professionals brings diverse expertise in Taxation,VAT, RJSC, BIDA,
            accounting, business formation, and regulatory compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          <div className="bg-psa-green-50 p-8 rounded-lg text-center transition-transform hover:-translate-y-2 duration-300">
            <div className="bg-psa-green-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <Clock size={28} className="text-psa-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Years of Experience
            </h3>
            <p className="text-gray-600">
              Over 18 years of professional excellence in Tax, VAT, RJSC, BIDA
              and business consultancy.
            </p>
          </div>

          <div className="bg-psa-green-50 p-8 rounded-lg text-center transition-transform hover:-translate-y-2 duration-300">
            <div className="bg-psa-green-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <BookOpen size={28} className="text-psa-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Expert Approach
            </h3>
            <p className="text-gray-600">
              Up-to-date knowledge of Tax laws, VAT laws, Company laws and
              regulatory requirements.
            </p>
          </div>

          <div className="bg-psa-green-50 p-8 rounded-lg text-center transition-transform hover:-translate-y-2 duration-300">
            <div className="bg-psa-green-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <Users size={28} className="text-psa-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Client Focus
            </h3>
            <p className="text-gray-600">
              Tailored solutions designed to meet each client's unique needs.
            </p>
          </div>

          <div className="bg-psa-green-50 p-8 rounded-lg text-center transition-transform hover:-translate-y-2 duration-300">
            <div className="bg-psa-green-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <Award size={28} className="text-psa-green-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Professional Excellence
            </h3>
            <p className="text-gray-600">
              Commitment to highest standards of integrity and service.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;
